module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/FIRE_ELEMENTAL_STYLE.10712b89.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/FIRE_ELEMENTAL_STYLE.png
// module id = 1154
// module chunks = 16